import icTableColumnIndex from './main.vue'

/* istanbul ignore next */
icTableColumnIndex.install = function(Vue) {
  Vue.component(icTableColumnIndex.name, icTableColumnIndex)
}

export default icTableColumnIndex
